<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-mapeamento
      :fim="mapeamento.fimPerRespGestor"
      :inicio="mapeamento.inicioPerRespGestor"
      acesso="COMUM"
      titulo="Competências Técnicas"
    >
      <template v-slot:body>
        <v-col
          v-if="usuarioMapeamento.tipo === 'REGULAR' && (chefia || substituicaoChefia)"
          centered
          cols="12"
          no-gutters
        >
          <v-row
            v-if="prazoAtual || prazoEsgotado"
            no-gutters
          >
            <v-col>
              <v-form
                v-if="prazoAtual"
                ref="form"
                v-model="valid"
              >
                <v-row dense>
                  <v-toolbar flat>
                    <v-toolbar-title>
                      <h2
                        class="
                          title
                          primary--text
                          text--darken-1 text-no-wrap
                          mt-0
                        "
                      >
                        CADASTRO DAS RESPONSABILIDADES
                      </h2>
                    </v-toolbar-title>
                  </v-toolbar>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field
                      id="titulo"
                      v-model.trim="responsabilidade.titulo"
                      :rules="rules.responsabilidades"
                      color="primary"
                      label="Responsabilidade"
                      prepend-icon="done"
                      required
                      tabindex="1"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-select
                      v-model="responsabilidade.dificuldade"
                      :items="dificuldades"
                      :rules="rules.dificuldades"
                      class="mr-4"
                      color="primary"
                      item-text="descricao"
                      label="Nível de Dificuldade"
                      prepend-icon="how_to_reg"
                      required
                      tabindex="2"
                      return-object
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="responsabilidade.impacto"
                      :items="impactos"
                      :rules="rules.impactos"
                      color="primary"
                      item-text="descricao"
                      label="Nível de Impacto"
                      prepend-icon="warning"
                      required
                      tabindex="3"
                      return-object
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="responsabilidade.competenciasTecnicas"
                      :items="competenciasTecnicas"
                      :rules="rules.competenciasTecnicas"
                      :search-input.sync="pesquisaCompetencia"
                      chips
                      class="mr-4"
                      color="primary"
                      deletable-chips
                      item-text="nomeAtual"
                      label="Competências técnicas"
                      placeholder="Digite para pesquisar..."
                      multiple
                      no-results-text="Nenhum resultado encontrado."
                      prepend-icon="build"
                      required
                      return-object
                      tabindex="4"
                      @change="pesquisaCompetencia = ''"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :color="
                            data.item.unidades.length === 0
                              ? 'secondary'
                              : 'grey'
                          "
                          :input-value="data.selected"
                          class="chip--select-multi"
                          close
                          search=""
                          text-color="white"
                          @click:close="removeCompetencia(data.item)"
                        >
                          {{ data.item.nomeAtual }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="mt-4"
                          color="primary"
                          dark
                          text
                          @click="toogleCadastroCompetencia"
                          v-on="on"
                        >
                          Adicionar
                          <v-icon class="ml-2">
                            add_circle
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Clique para adicionar uma competência</span>
                    </v-tooltip>
                  </v-col>
                  <v-spacer />
                </v-row>
                <v-row
                  class="justify-end"
                  no-gutters
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :disabled="!valid"
                        class="mr-2"
                        color="primary"
                        tabindex="7"
                        @click="salvar"
                        v-on="on"
                      >
                        {{ btnSalvar }}
                      </v-btn>
                    </template>
                    <span>
                      {{
                        !isEditando
                          ? 'Clique no botão para cadastrar uma responsabilidade'
                          : 'Clique no botão para editar a responsabilidade'
                      }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :disabled="!isFormUpdated"
                        color="primary"
                        outlined
                        @click="clearFields()"
                        v-on="on"
                      >
                        Cancelar
                      </v-btn>
                    </template>
                    <span>Clique no botão para cancelar a operação</span>
                  </v-tooltip>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
          <v-row
            v-if="prazoAtual || prazoEsgotado"
          >
            <v-toolbar flat>
              <v-toolbar-title>
                <h2
                  class="title primary--text text--darken-1 text-no-wrap mb-4"
                >
                  RESPONSABILIDADES ({{ responsabilidades.length }})
                </h2>
              </v-toolbar-title>
            </v-toolbar>
          </v-row>
          <v-row
            v-if="prazoAtual || prazoEsgotado"
            no-gutters
          >
            <v-col
              cols="12"
              md="4"
            >
              <app-sort v-model="opcoes" />
            </v-col>
            <v-col
              cols="0"
              md="4"
            />
            <v-col
              cols="12"
              md="4"
            >
              <app-search v-model="opcoes" />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-data-table
                :headers="headers"
                :items="responsabilidades"
                :search="opcoes.pesquisa"
                :sort-by="opcoes.ordenarPor"
                :sort-desc="opcoes.decrescente"
                class="elevation-0"
                item-key="id"
                show-expand
                single-expand
              >
                <template
                  v-slot:[`item.data-table-expand`]="{
                    item,
                    expand,
                    isExpanded,
                  }"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        height="100%"
                        text
                        width="100%"
                        @click="
                          expand(!isExpanded),
                          gerarColunas(item.competenciasTecnicas)
                        "
                        v-on="on"
                      >
                        <v-badge right>
                          <template v-slot:badge>
                            <span>{{ item.competenciasTecnicas.length }}</span>
                          </template>
                          <v-icon
                            color="grey lighten-0"
                            large
                          >
                            build
                          </v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <span>Clique para exibir as competências técnicas</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`expanded-item`]="{ headers }">
                  <td
                    :colspan="headers.length"
                    class="justify-center"
                  >
                    <v-row dense>
                      <v-spacer />
                      <v-col>
                        <v-row class="justify-center">
                          <h2
                            class="
                              title
                              primary--text
                              text--darken-1 text-no-wrap
                            "
                          >
                            COMPETÊNCIAS TÉCNICAS
                          </h2>
                        </v-row>
                      </v-col>
                      <v-spacer />
                    </v-row>
                    <v-row>
                      <v-spacer />
                      <v-col cols="10">
                        <v-simple-table
                          class="elevation-0 mb-4"
                          dense
                        >
                          <template v-slot:default>
                            <tbody>
                              <tr
                                v-for="column in colunas.lista"
                                :key="column.id"
                              >
                                <td
                                  v-for="item in column"
                                  :key="item.id"
                                  width="30%"
                                >
                                  <div class="d-flex flex-row ma-1">
                                    <span
                                      :class="
                                        item.tipo === 'GERAL'
                                          ? 'secondary--text'
                                          : 'grey-text text--darken-2'
                                      "
                                    >
                                      {{ item.nomeAtual }}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                      <v-spacer />
                    </v-row>
                  </td>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <v-col>
                    <v-tooltip
                      max-width="500"
                      top
                    >
                      <template v-slot:activator="{ on }">
                        <v-chip
                          class="ml-1"
                          color="success white--text"
                          label
                          small
                          v-on="on"
                        >
                          Dificuldade
                          {{ item.dificuldade.valor }}
                        </v-chip>
                      </template>
                      <span>{{ item.dificuldade.descricao }}</span>
                    </v-tooltip>
                    <v-tooltip
                      max-width="500"
                      top
                    >
                      <template v-slot:activator="{ on }">
                        <v-chip
                          class="ml-1"
                          color="secondary white--text"
                          label
                          small
                          v-on="on"
                        >
                          Impacto
                          {{ item.impacto.valor }}
                        </v-chip>
                      </template>
                      <span>{{ item.impacto.descricao }}</span>
                    </v-tooltip>
                  </v-col>
                </template>
                <template v-slot:[`item.acoes`]="{ item }">
                  <v-col>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="prazoAtual"
                          class="mr-2"
                          color="secondary"
                          icon
                          small
                          @click="editItem(item)"
                          v-on="on"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique no botão para editar a responsabilidade</span>
                    </v-tooltip>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="prazoAtual"
                          color="error"
                          icon
                          small
                          @click="confirmDeleteItem(item)"
                          v-on="on"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique no botão para excluir a responsabilidade</span>
                    </v-tooltip>
                  </v-col>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else>
          <app-alert
            :message="`Usuário não realiza cadastro de responsabilidade.`"
          />
        </v-col>
      </template>
      <template v-slot:actions>
        <v-row no-gutters>
          <div
            v-show="prazoAtual && (chefia || substituicaoChefia) && usuarioMapeamento.tipo === 'REGULAR'"
            class="text-lg-right mt-3 mb-3"
          >
            <v-tooltip
              :disabled="responsabilidades.length === 0"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="responsabilidades.length === 0"
                  class="mr-2"
                  color="secondary"
                  outlined
                  @click="toogleDialogAgradecimento()"
                  v-on="on"
                >
                  Finalizar
                  <v-icon class="ml-2">
                    check
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique no botão para finalizar o Cadastro das
                Responsabilidades</span>
            </v-tooltip>
          </div>
        </v-row>
      </template>
    </app-mapeamento>

    <dialog-remove
      :confirm-action="deleteItem"
      :dialog-visible="dialogRemove.visible"
      :toogle-visible="toogleDialogRemove"
      descricao="Você realmente deseja excluir essa responsabilidade?"
    />

    <dialog-agradecimento
      :dialog-visible="dialogAgradecimento.visible"
      :toogle-visible="toogleDialogAgradecimento"
      descricao="Agradecemos pela sua colaboração!
                Você ainda poderá participar do Cadastro das Responsabilidades até o período estabelecido."
      url-redirecionamento="/mapeamento"
    />

    <cadastro-edicao-competencia
      :competencia="competencia"
      :is-edicao="false"
      :mapeamento="mapeamento"
      :toogle="toogleCadastroCompetencia"
      :visibilidade="dialogCompetencia"
      etapa="cadastro"
      @hide="toogleCadastroCompetencia"
      @return="(value) => addCompetencia(value)"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import DialogRemove from '@/components/DialogRemove';
import AppMapeamento from '@/components/core/AppMapeamento';
import DialogAgradecimento from '@/components/DialogAgradecimento';
import CadastroEdicaoCompetencia from '@/components/mapeamento/CadastroEdicaoCompetencia';
import AppAlert from '@/components/core/AppAlert';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const responsabilidadeRepository = RepositoryFactory.get('responsabilidade');

export default {
  name: 'CadastroResponsabilidade',

  components: {
    AppSort,
    AppSearch,
    DialogRemove,
    AppMapeamento,
    DialogAgradecimento,
    CadastroEdicaoCompetencia,
    AppAlert,
  },

  data() {
    return {
      isEditando: false,
      btnSalvar: 'Cadastrar',
      headers: [
        {
          text: 'RESPONSABILIDADES',
          value: 'titulo',
          sortable: false,
          width: '40%',
        },
        {
          text: 'COMPETÊNCIAS TÉCNICAS',
          value: 'data-table-expand',
          width: '25%',
          align: 'center',
        },
        {
          text: '',
          value: 'status',
          sortable: false,
          width: '10%',
        },
        {
          text: '',
          value: 'acoes',
          sortable: false,
          width: '25%',
          align: 'end',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: '',
        selecionado: null,
        lista: [
          { id: 'titulo', descricao: 'Responsabilidade' },
          { id: 'dificuldade.valor', descricao: 'Grau de Dificuldade' },
          { id: 'impacto.valor', descricao: 'Grau de Impacto' },
          { id: 'competenciasAtuais.length', descricao: 'Número de Competências' },
        ],
      },
      dialogRemove: {
        visible: false,
        item: {},
      },
      dialogAgradecimento: {
        visible: false,
      },
      responsabilidade: {
        id: null,
        titulo: '',
        impacto: null,
        dificuldade: null,
        original: true,
        competenciasTecnicas: [],
        competenciasTecnicasChefia: [],
        competenciasTecnicasComissao: [],
        competenciasTecnicasConsolidado: [],
      },
      rules: {
        responsabilidades: [(v) => !!v || 'Insira uma nova responsabilidade'],
        impactos: [(v) => !!v || 'Selecione o nível de impacto da responsabilidade'],
        dificuldades: [(v) => !!v || 'Selecione o nível de dificuldade da responsabilidade'],
        competenciasTecnicas: [
          (v) => (v !== undefined && v.length > 0) || 'Adicione pelo menos uma competência técnica',
        ],
      },
      pesquisaCompetencia: null,
      dificuldades: [
        {
          id: 'UM',
          valor: 1,
          descricao:
            '1 - Atividade está organizada ou estruturada '
            + '(requer aplicação básica de suas competências para realizar a atividade)',
        },
        {
          id: 'DOIS',
          valor: 2,
          descricao:
            '2 - Atividade pouco organizada ou estruturada '
            + '(requer aplicação intermediária de suas competências para realizar a atividade)',
        },
        {
          id: 'TRES',
          valor: 3,
          descricao:
            '3 - Atividade ainda sem organização ou estruturas definidas '
            + '(requer aplicação máxima de suas competências para realizar a atividade)',
        },
      ],
      impactos: [
        { id: 'UM', valor: 1, descricao: '1 - Fica limitado ao setor' },
        { id: 'DOIS', valor: 2, descricao: '2 - Afeta várias áreas, mas é administrável' },
        { id: 'TRES', valor: 3, descricao: '3 - Ultrapassa os portões da instituição' },
      ],
      competencia: { nome: '', unidades: [] },
      dialogCompetencia: false,
      colunas: {},
      valid: false,
    };
  },

  computed: {
    ...mapState({
      mapeamento: (state) => state.mapeamento.mapeamento,
      unidade: (state) => state.mapeamento.usuarioMapeamento.unidade,
      chefia: (state) => state.mapeamento.usuarioMapeamento.chefia,
      substituicaoChefia: (state) => state.mapeamento.usuarioMapeamento.substituicaoChefia,
      isTutorialExibido: (state) => state.tutorial.dados.cadastroResponsabilidade,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
    }),
    ...mapGetters({
      getCompetenciasTecnicas: 'competencia/getCompetenciasTecnicas',
    }),
    loaded: {
      get() {
        return this.$store.state.responsabilidade.loaded;
      },
      set(loaded) {
        this.$store.dispatch('responsabilidade/setLoaded', loaded);
      },
    },
    responsabilidades() {
      return this.responsabilidadesArmazenadas.filter((r) => r.unidade.id === this.unidade.idVersao);
    },
    responsabilidadesArmazenadas: {
      get() {
        return this.$store.state.responsabilidade.responsabilidades;
      },
      set(responsabilidades) {
        this.$store.dispatch('responsabilidade/setResponsabilidades', responsabilidades);
      },
    },
    isFormUpdated() {
      return (
        (this.responsabilidade.titulo && this.responsabilidade.titulo.length !== 0)
        || this.responsabilidade.impacto != null
        || this.responsabilidade.dificuldade != null
        || (this.responsabilidade.competenciasTecnicas && this.responsabilidade.competenciasTecnicas.length !== 0)
      );
    },
    competenciasTecnicas() {
      return this.getCompetenciasTecnicas({ unidadeId: this.unidade.idVersao, mapeamentoId: this.mapeamento.id });
    },
    prazoAtual() {
      return !this.prazoEsgotado && !this.prazoFuturo;
    },
    prazoEsgotado() {
      return Data.compare('isAfter', { b: this.mapeamento.fimPerRespGestor });
    },
    prazoFuturo() {
      return Data.compare('isBefore', { b: this.mapeamento.inicioPerRespGestor });
    },
  },

  watch: {
    mapeamento() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.loadResponsabilidades();
    },
  },

  created() {
    this.loadResponsabilidades();
  },

  methods: {
    loadResponsabilidades() {
      if (
        (this.chefia || this.substituicaoChefia)
        && (this.loaded.mapeamento !== this.mapeamento.id || !this.loaded.status)
        && (this.prazoAtual || this.prazoEsgotado)
      ) {
        const payload = { mapeamento: this.mapeamento.id, comissao: false };
        this.$store.dispatch('responsabilidade/load', payload).then(() => {
          this.loaded.mapeamento = this.mapeamento.id;
          this.loaded.status = true;
          if (!this.isTutorialExibido && this.prazoAtual) {
            this.$store.dispatch('app/showTutorial', { nome: 'CadastroResponsabilidade' });
          }
        });
      }
    },
    editItem(item) {
      window.scrollTo({
        top: 100,
        left: 0,
        behavior: 'smooth',
      });
      this.isEditando = true;
      this.btnSalvar = 'Editar';
      this.responsabilidade = JSON.parse(JSON.stringify(item));
      this.responsabilidade.competenciasAtuais = [];
      this.responsabilidade.impactoAtual = null;
      this.responsabilidade.dificuldadeAtual = null;
    },
    salvar() {
      if (this.isEditando) {
        responsabilidadeRepository
          .update('CADASTRO_RESPONSABILIDADES', this.responsabilidade.id, this.responsabilidade)
          .then(async (res) => {
            const responsabilidade = res.data;
            await this.gerarColunas(res.data.competenciasTecnicas);

            if (responsabilidade.id) {
              const index = this.responsabilidadesArmazenadas.findIndex((r) => r.id === responsabilidade.id);
              if (index !== -1) {
                this.responsabilidadesArmazenadas.splice(index, 1, responsabilidade);
                await this.$store.dispatch('app/success', {
                  response: res,
                  message: 'Responsabilidade atualizada com sucesso!',
                });
              }
            }
            this.clearFields();
          });
      } else {
        responsabilidadeRepository.create(this.mapeamento.id, this.responsabilidade).then((res) => {
          this.responsabilidadesArmazenadas.push(res.data);
          this.$store.dispatch('app/success', { response: res, message: 'Responsabilidade cadastrada com sucesso!' });
          this.clearFields();
          this.opcoes.selecionado = null;
          this.opcoes.decrescente = true;
          this.opcoes.ordenarPor = 'id';
        });
      }
    },
    confirmDeleteItem(item) {
      this.dialogRemove.item = item;
      this.toogleDialogRemove();
    },
    deleteItem() {
      if (this.dialogRemove.item.id) {
        responsabilidadeRepository.delete(this.dialogRemove.item.id).then((res) => {
          const index = this.responsabilidadesArmazenadas.findIndex((c) => c.id === this.dialogRemove.item.id);
          if (index !== -1) {
            this.responsabilidadesArmazenadas.splice(index, 1);
            this.$store.dispatch('app/success', { response: res, message: 'Responsabilidade excluída com sucesso!' });
          }
          this.toogleDialogRemove();
        });
      }
    },
    addCompetencia(competencia) {
      this.responsabilidade.competenciasTecnicas.push(competencia);
    },
    removeCompetencia(item) {
      const index = this.responsabilidade.competenciasTecnicas.findIndex((c) => c.id === item.id);
      if (index !== -1) {
        this.responsabilidade.competenciasTecnicas.splice(index, 1);
      }
    },
    toogleDialogRemove() {
      this.dialogRemove.visible = !this.dialogRemove.visible;

      if (!this.dialogRemove.visible) {
        this.dialogRemove.item = {};
      }
    },
    toogleDialogAgradecimento() {
      this.dialogAgradecimento.visible = !this.dialogAgradecimento.visible;
    },
    toogleCadastroCompetencia() {
      this.competencia.unidades = [{ id: this.usuarioMapeamento.unidade.idVersao }];
      this.dialogCompetencia = !this.dialogCompetencia;

      if (!this.dialogCompetencia) {
        this.competencia.id = null;
        this.competencia.nome = '';
      }
    },
    gerarColunas(itens) {
      const columns = {
        id: '',
        lista: [],
      };
      const mid = Math.ceil(itens.length / 3);

      for (let col = 0; col < mid; col += 1) {
        columns.id = col;
        columns.lista.push(itens.slice(col * 3, col * 3 + 3));
      }

      this.colunas = columns;
    },
    clearFields() {
      this.isEditando = false;
      this.btnSalvar = 'Cadastrar';
      this.responsabilidade = {
        id: null,
        titulo: '',
        impacto: null,
        dificuldade: null,
        original: true,
        competenciasTecnicas: [],
      };
      this.$refs.form.resetValidation();
    },
  },
};
</script>
